// extracted by mini-css-extract-plugin
module.exports = {"collapsibleSplitter":"collapsible-splitter_collapsibleSplitter__hYvyv","handle":"collapsible-splitter_handle__31tvT","actionBox":"collapsible-splitter_actionBox__21u5q"};